import template from './was-this-useful-reasons.component.html';
var WasThisUsefulReasonsComponentController = /** @class */ (function () {
    function WasThisUsefulReasonsComponentController() {
        this.reasons = [];
    }
    WasThisUsefulReasonsComponentController.$inject = [];
    return WasThisUsefulReasonsComponentController;
}());
export var WasThisUsefulReasonsComponent = {
    bindings: {
        onReasonChange: '&?',
        reasons: '<',
    },
    controller: WasThisUsefulReasonsComponentController,
    template: template,
};
